/**
 * Route names the app layer depends on — the legacy names (wp/shell §3). The shell module declares the pages
 * (`src/modules/shell/routes.ts`); other modules' names come from the route manifest.
 */
export const ROUTE_HOME = 'home'
export const ROUTE_LOGIN = 'auth-login'
export const ROUTE_REGISTER = 'auth-register'
export const ROUTE_FORGOT_PASSWORD = 'auth-forgot-password'
export const ROUTE_SET_PASSWORD = 'auth-set-password'
export const ROUTE_NOT_AUTHORIZED = 'misc-not-authorized'
export const ROUTE_NOT_FOUND = 'error-404'
export const ROUTE_MAINTENANCE = 'under-maintenance'
export const ROUTE_PROFILE = 'pages-profile'
